import {tasksSettingType} from "./getTasksSettings";
import {basePatchRequest} from "../base/basePatchRequest";

const patchTasksSetting = async (id: number, tasksSetting: tasksSettingType) =>
  basePatchRequest<tasksSettingType>(`/tasks_setting/${id}/`, tasksSetting);

export default patchTasksSetting;
